import { useEffect } from 'react';

import { citationWizardHandoffStore } from '../state/citationWizardHandoffStore';
import { deleteStatementTriageStore } from '../state/statementTriageStore';

/**
 * Releases the per-message triage store tied to a chat message when the
 * bubble unmounts (or when `messageSid` changes). The triage store
 * (`statementTriageStore`) also holds the Review-phase help-request
 * drafts; without this, the registry accumulates entries indefinitely
 * as the user scrolls a long conversation that contains many
 * extracted-statement messages.
 *
 * Extracted from `ExtractedStatementsBubble` so the lifecycle
 * contract is testable without rendering the full bubble tree.
 *
 * # Wizard-open guard
 *
 * The triage store deletion is skipped when the native citation-wizard
 * route is currently open for this message. If the bubble scrolls
 * off-screen while the wizard is mounted, the store must survive so the
 * wizard's active session (phase snapshot + help-request drafts) and
 * any subsequent realtime-hydration call resolve the same instance.
 * Cleanup is deferred to the wizard route's unmount effect via
 * `clearCitationWizardHandoff`, which nulls the handoff payload and
 * lets the next bubble-unmount cycle run the deletion normally.
 */
export function useStatementReferencesStoreCleanup(messageSid: string): void {
  useEffect(() => {
    return () => {
      const wizardPayload = citationWizardHandoffStore.getState().payload;

      if (wizardPayload?.messageSid !== messageSid) {
        deleteStatementTriageStore(messageSid);
      }
    };
  }, [messageSid]);
}
